import { isNotNil } from "@etudescarre/utils";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import { authClient } from "@/lib/auth-client";

type SessionContextValue = {
  session: ReturnType<typeof authClient.useSession>["data"];
  isSessionLoading: boolean;
  isAuthenticated: boolean;
  hasSessionError: boolean;
};

const SessionContext = createContext<SessionContextValue | null>(null);

type SessionProviderProps = {
  children: ReactNode;
};

export function SessionProvider({ children }: SessionProviderProps) {
  const {
    data: session,
    isPending: isSessionLoading,
    error: sessionError,
  } = authClient.useSession();
  const isAuthenticated = !!session?.session?.token;
  const hasSessionError = isNotNil(sessionError);

  return (
    <SessionContext.Provider
      value={{
        session,
        isSessionLoading,
        isAuthenticated,
        hasSessionError,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
}
